import { Module, Mutation, VuexModule } from "vuex-module-decorators";
import ClubDto, { emptyClubDto } from "@/dtos/ClubDto";

export interface ShowDialogData {
  isShowing: boolean;
  clubDto: ClubDto | null;
}

@Module({ namespaced: true })
export class ClubDialogModule extends VuexModule {
  private _isShowing = false;
  private _data: ClubDto | null = null;

  @Mutation
  public show(data: ShowDialogData): void {
    this._isShowing = data.isShowing;
    if (data.isShowing) {
      this._data = data.clubDto || emptyClubDto();
    } else {
      this._data = null;
    }
  }

  public get isShowing(): boolean {
    return this._isShowing;
  }

  @Mutation
  public hide(): void {
    this._isShowing = false;
  }

  public get clubDto(): ClubDto | null {
    return this._data;
  }
}
